import {Component, OnInit} from '@angular/core';
import {ActionSheetController} from "@ionic/angular";
import {Router} from "@angular/router";

@Component({
  selector: 'app-verificar-cliente',
  templateUrl: './verificar-cliente.page.html',
  styleUrls: ['./verificar-cliente.page.scss'],
})
export class VerificarClientePage implements OnInit {

  exception: boolean;
  constructor(public actionSheetController: ActionSheetController, private router: Router) {
  }


  ngOnInit() {
  }

  actionSheet(){
    if (!this.exception){
      this.presentActionSheet().then();
    }

  }
  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      mode: 'ios',
      buttons: [{
        text: 'Amputaciones',
        role: 'destructive',
        handler: () => {
          console.log('Amputaciones clicked');
        }
      }, {
        text: 'Malformaciones',
        handler: () => {
          console.log('Malformaciones clicked');
        }
      }, {
        text: 'Injertos',
        handler: () => {
          console.log('Injertos clicked');
        }
      }, {
        text: 'Lesión permanente',
        handler: () => {
          console.log('Lesión permanente clicked');
        }
      }, {
        text: 'Prótesis',
        handler: () => {
          console.log('Prótesis clicked');
        }
      }, {
        text: 'Enfermadad',
        handler: () => {
          console.log('Enfermadad clicked');
        }
      }, {
        text: 'Otros',
        handler: () => {
          console.log('Otros clicked');
        }
      }, {
        text: 'Cancelar',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  captureFootprints(){
    this.router.navigate(['/dashboard/finger', {enroll: true}]).then();

  }

}
